export type GermanPositionType = "BEL" | "NBL" | "EDM" | "MAT" | "RBT";

export type AbrechnungsbereichType =
	| "BE" | "BBG" | "BW" | "BY" | "HB" | "HH" | "HS" | "MVO"
	| "NR" | "NS" | "RP" | "SAA" | "SA" | "SAN" | "SH" | "TH" | "WL" 
	| "NONE" | "";
export interface GermanPosition {
	art: GermanPositionType;
	nummer?: string;
	beschreibung: string;
	einzelpreis: number;
	menge: number;
}

export interface MWSTGruppe {
	positionen: GermanPosition[];
	zwischensumme_netto: number;
	mehrwertsteuersatz: number;
	mehrwertsteuerbetrag: number;
}

export interface GermanLabInvoice {
	laborname: string;
	laborsoftware: string;
	laborsoftwarehersteller: string;
	laborsoftwareversion: string;
	laborId?: string;
	herstellungsort: string;
	abrechnungsbereich: AbrechnungsbereichType;
	laborlieferdatum: string;
	laborrechnungsnummer: string;
	auftragsnummer: string;
	gesamtbetrag_netto: number;
	mehrwertsteuer_gesamt: number;
	gesamtbetrag_brutto: number;
	mwstGruppen: MWSTGruppe[];
}

export interface GermanLabExportData {
	rechnung: GermanLabInvoice;
}

export interface GermanXmlExportRpcData {
	organization: {
		name: string;
		city: string;
		country: string;
		billing_region: string | null;
	};
	client: {
		country: string;
		billing_region: string | null;
		default_activated_region_id: number | null;
	};
	job: {
		tax_rate: number;
		code: string;
	};
	job_document: {
		id: number;
		date: string;
		amount: number;
		type: string;
		discount_work: number;
		discount_material: number;
	};
	invoice: {
		doc_number: string;
	} | null;
	job_items: Array<{
		id: string;
		type: number;
		cluster: string | null;
		code_e: string;
		description: string;
		price: number;
		quantity: number;
		discount: number;
		tp_value: number;
	}>;
}

export interface GermanXmlValidationResult {
	isValid: boolean;
	errors: string[];
	warnings: string[];
}

export const BEL2_CATALOG_NAME = "BEL II";

export const ABRECHNUNGSBEREICH_OPTIONS: { value: AbrechnungsbereichType; label: string }[] = [
	{ value: "NONE", label: "Kein Abrechnungsbereich" },
	{ value: "BE", label: "Berlin" },
	{ value: "BBG", label: "Brandenburg" },
	{ value: "BW", label: "Baden-Württemberg" },
	{ value: "BY", label: "Bayern" },
	{ value: "HB", label: "Bremen" },
	{ value: "HH", label: "Hamburg" },
	{ value: "HS", label: "Hessen" },
	{ value: "MVO", label: "Mecklenburg-Vorpommern" },
	{ value: "NR", label: "Nordrhein" },
	{ value: "NS", label: "Niedersachsen" },
	{ value: "RP", label: "Rheinland-Pfalz" },
	{ value: "SAA", label: "Saarland" },
	{ value: "SA", label: "Sachsen" },
	{ value: "SAN", label: "Sachsen-Anhalt" },
	{ value: "SH", label: "Schleswig-Holstein" },
	{ value: "TH", label: "Thüringen" },
	{ value: "WL", label: "Westfalen-Lippe" },
];

export const COUNTRY_GERMAN_NAMES: Record<string, string> = {
	ch: "Schweiz",
	at: "Österreich",
	it: "Italien",
	fr: "Frankreich",
	li: "Liechtenstein",
};
